module.exports = __webpack_public_path__ + "media/images/webpage/hotels/1319/room-d4dea767f94d31c7667696e756a57f1d.webp";